// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3669":"3f7af96c","8786":"8bb54fe6"}[chunkId] + ".css";
};